export const isSlackSubmission = (submission) => {
    return submission.userName.startsWith('slack');
};
export const isWhatsAppSubmission = (submission) => {
    return submission.userName.startsWith('whatsApp:');
};
